import React from 'react';

const VerificationFailurePage: React.FC = () => {
  const handleNextVerification = () => {
    window.location.href = '/';
  };

  return (
    <div className="App" style={{ maxWidth: '600px', margin: '0 auto', padding: '20px' }}>
      <div style={{ 
        backgroundColor: '#ffffff', 
        borderRadius: '8px', 
        padding: '40px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'center'
      }}>
        <div style={{ marginBottom: '30px' }}>
          <h1 style={{ color: '#dc3545', fontSize: '28px', marginBottom: '20px' }}>
            ⚠️ Несоответствие данных
          </h1>
          <div style={{
            padding: '20px',
            backgroundColor: '#fff3cd',
            borderRadius: '8px',
            border: '1px solid #ffc107',
            fontSize: '16px',
            lineHeight: '1.6',
            color: '#856404'
          }}>
            <p style={{ margin: 0, fontWeight: '600', marginBottom: '10px' }}>
              Верификация не пройдена
            </p>
            <p style={{ margin: 0 }}>
              Введенные данные (ПИНФЛ и дата рождения) не соответствуют данным верифицированного лица.
            </p>
            <p style={{ margin: '15px 0 0 0', fontWeight: '600' }}>
              Пожалуйста, проверьте правильность введенных данных и попробуйте снова.
            </p>
          </div>
        </div>

        <button
          className="primary-button"
          onClick={handleNextVerification}
          style={{ 
            padding: '12px 32px', 
            fontSize: '16px',
            minWidth: '200px'
          }}
        >
          Проверить следующего
        </button>
      </div>
    </div>
  );
};

export default VerificationFailurePage;

